module.exports = "/_next/static/images/ico_spr.ZQtFC4la.png";